import React, { useState } from "react";
import clienteAxios from "../../axios"; // Asegúrate de que la ruta sea correcta

const ModalAgregarArticuloPedido = ({ show, onClose, pedidoId, onArticuloAgregado }) => {
    const [nuevoArticulo, setNuevoArticulo] = useState({
        articulo_menu_id: "",
        cantidad: "",
        precio: ""
    });

    const handleAgregarArticulo = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "articulos_pedido",
                pedido_id: pedidoId,
                articulo_menu_id: nuevoArticulo.articulo_menu_id,
                cantidad: nuevoArticulo.cantidad,
                precio: nuevoArticulo.precio
            });
            setNuevoArticulo({ articulo_menu_id: "", cantidad: "", precio: "" });
            onArticuloAgregado();  // Actualizamos la lista de artículos al agregar
            onClose();  // Cerramos el modal
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) {
        return null; // No renderizamos el modal si `show` es false
    }

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-lg font-semibold mb-4">Agregar Nuevo Artículo</h2>
                <form onSubmit={handleAgregarArticulo}>
                    <input
                        type="text"
                        placeholder="ID del Artículo"
                        value={nuevoArticulo.articulo_menu_id}
                        onChange={(e) => setNuevoArticulo({ ...nuevoArticulo, articulo_menu_id: e.target.value })}
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <input
                        type="number"
                        placeholder="Cantidad"
                        value={nuevoArticulo.cantidad}
                        onChange={(e) => setNuevoArticulo({ ...nuevoArticulo, cantidad: e.target.value })}
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <input
                        type="number"
                        placeholder="Precio"
                        value={nuevoArticulo.precio}
                        onChange={(e) => setNuevoArticulo({ ...nuevoArticulo, precio: e.target.value })}
                        className="border rounded-lg p-2 mb-4 w-full"
                        maxLength={15}
                    />
                    <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded mr-2">
                        Agregar Artículo
                    </button>
                    <button type="button" onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded">
                        Cancelar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarArticuloPedido;
